module.exports = __webpack_public_path__ + "media/images/badges/clubpilates/milestone-2-Active-ClubPilates-9c1c015227df9d8fdbb0d9b4cf1cd1e1.png";